import React from 'react';
import { Navigate } from 'react-router-dom';

const RedirectComponent = () => {
  return <Navigate to="/events" replace />;
};

export default RedirectComponent;